<template>
  <transition name="fade">
    <div class="toast" v-show="show" :class="[typeClass, positionClass]">
      <div class="toast-icon" v-if="type != 'text'">
        <img :src="imgSrc" :alt="type" />
      </div>
      <p class="toast-content" v-if="msg">{{ msg }}</p>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      msg: "",
      position: "middle",
      type: "text",
      duration: 2500
    };
  },
  created() {
    // this.show = true;
  },
  computed: {
    typeClass() {
      return "toast_" + this.type;
    },
    positionClass() {
      return "toast-" + this.position;
    },
    imgSrc() {
      return require("./assets/" + this.type + ".png");
    }
  },
  watch: {
    show(val) {
      if (val) {
        setTimeout(() => {
          this.show = false;
        }, this.duration);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 80%;
  padding: 16px 30px;
  font-size: 28px;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  z-index: 99999;
  transform: translate(-50%, -50%);
}
.fade-enter-active,
.fade-leave-active {
  transition: 0.3s ease-out;
}
.fade-enter {
  opacity: 0;
  // transform: scale(1.2);
}
.fade-leave-active {
  opacity: 0;
  // transform: scale(0.8);
}
.toast-top {
  top: 10%;
  transform: translateX(-50%);
}
.toast-bottom {
  top: auto;
  transform: translateX(-50%);
  bottom: 15%;
}
.toast_success {
  // color: #e74e3a;
  width: 200px;
  height: 200px;
}
.toast_cancel {
  color: #e74e3a;
  width: 200px;
  height: 200px;
}
.toast_warn {
  color: #de6e18;
  width: 200px;
  height: 200px;
}
.toast-icon {
  margin-top: 16px;
  margin-bottom: 20px;
}
.toast-icon img {
  width: 112px;
  display: block;
  margin: 0 auto;
}
.toast-content {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}
</style>
